import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as ACTIONS from '../../actions';
import drawings from '../../services/Drawing';
import { API_SERVICE } from '../../services/CommonApi';

const initialState = {
  drawingAreas: [],
  editArea: {},
  savePDFCoordinate: {},
  annotateCoordinates: null,
  author: false,
  set_name: '',
  pdf_auto_scan_attrs: {
    coordinates_defined: false,
    auto_scan_initiated: false,
    auto_scan_completion: false
  },
  ocr_progress: {},
  scanEnable: false,
  drawingList: [],
  drawingPendingList: [],
  drawingSetList: [],
  uploadLogs: [],
  existingDrawingSet: [],
  approvalDrawing: false,
  fileName: '',
  title: '-',
  number: '-',
  titleCoordinates: null,
  numberCoordinates: null,
  referencePageDimensions: null,
  dimensionGroups: [],
  activeGroupSignature: null,
  groupCoordinates: {},
  rowModify: false,
  redefineModalOpen: false,
  redefineRecord: null,
  pageTitleCoordinates: null,
  pageNumberCoordinates: null
};

let deleteID = '';

export const addDrawingArea = createAsyncThunk(ACTIONS.ADD_DRAWING_AREA, async (arg, thunkAPI) => {
  try {
    return await API_SERVICE.post(`${drawings.addDrawingArea(arg.projectId)}`, arg.payload, '');
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const getDrawingAreas = createAsyncThunk(
  ACTIONS.VIEW_DRAWING_AREA_LIST,
  async (arg, thunkAPI) => {
    console.log(drawings?.getDrawingAreaList(), arg, 'API_SERVICE');
    try {
      return await API_SERVICE.get(`${drawings.getDrawingAreaList(arg.projectId)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getDrawingVersionSummary = createAsyncThunk(
  'DRAWING/VERSION_SUMMARY',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.drawingVersionSummary(arg.id)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const refreshDrawingVersionPdfUrl = createAsyncThunk(
  'DRAWING/VERSION_PDF_URL_REFRESH',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.drawingVersionPdfUrl(arg.id)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const editDrawingArea = createAsyncThunk(
  ACTIONS.EDIT_DRAWING_AREA,
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.getEditArea(arg.projectId, arg.editID)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const updateDrawingArea = createAsyncThunk(
  ACTIONS.UPDATE_DRAWING_AREA,
  async (arg, thunkAPI) => {
    try {
      const response = await API_SERVICE.patch(
        `${drawings.updateDrawingArea(arg.projectId, arg.editID)}`,
        arg.payload
      );
      thunkAPI.dispatch(getDrawingAreas());
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const deleteDrawingArea = createAsyncThunk(
  ACTIONS.DELETE_DRAWING_AREA,
  async (arg, thunkAPI) => {
    console.log(arg, 'deleeeeee');
    try {
      const response = await API_SERVICE.delete(
        `${drawings.deleteDrawingArea(arg.projectId, arg.deleteID)}`
      );
      deleteID = arg.deleteID;
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getDrawingList = createAsyncThunk(
  'DRAWING/VIEW_DRAWING_LIST',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.getDrawingList(arg.projectId)}`, { set: arg.set });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getDrawingSetList = createAsyncThunk(
  'DRAWING/VIEW_DRAWING_SET_LIST',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.getDrawingSetList(arg.projectId)}`, {
        drawing_discipline_id: arg.discipline_id,
        drawing_set_id: arg.set_id
      });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const saveUploadDrawing = createAsyncThunk(
  'DRAWING/CREATE_DRAWING_UPLOAD',
  async (arg, thunkAPI) => {
    //   console.log(drawings?.getDrawingAreaList(), arg, 'API_SERVICE');
    try {
      return await API_SERVICE.post(
        `${drawings.getDrawingUploadLog(arg.projectId)}`,
        arg.formData,
        true
      );
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getExistingDrawingSet = createAsyncThunk(
  'DRAWING/EXISTING_DRAWING_SET',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.loadDrawingSet(arg.companyId, arg.id)}`, {
        project_id: arg.projectId
      });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getUploadLogs = createAsyncThunk(
  ACTIONS.VIEW_UPLOAD_LOG_LIST,
  async (arg, thunkAPI) => {
    //   console.log(drawings?.getDrawingAreaList(), arg, 'API_SERVICE');
    try {
      return await API_SERVICE.get(`${drawings.getDrawingUploadLog(arg.projectId)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const drawingApproval = createAsyncThunk(
  'DRAWING/DRAWING_APPROVAL',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.put(
        `${drawings.uploadDrawingApproval(arg.projectId, arg.uploadId)}`
      );
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const drawingPendingApproval = createAsyncThunk(
  'DRAWING/DRAWING_PENDING',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.pendingDrawingApproval(arg.projectId, arg.id)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const drawingDefinedProperties = createAsyncThunk(
  'DRAWING/DRAWING_DEFINED_PROPERTIES',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.getDefinedProperties(arg.projectId, arg.id)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const processAutoScan = createAsyncThunk(
  'DRAWING/PROCESS_AUTO_SCAN',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.put(
        `${drawings.pdfAutoScanProcess(arg.projectId, arg.id)}`,
        arg.payload
      );
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const savePDFCoordinates = createAsyncThunk(
  'DRAWING/SAVE_COORDINATES',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.put(
        `${drawings.saveCoordinates(arg.projectId, arg.id)}`,
        arg.payload
      );
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const saveSheetDetails = createAsyncThunk(
  'DRAWING/saveSheetDetails',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.patch(`${drawings.saveSheetDetails(arg.id)}`, arg.payload);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const scanOCRExtraction = createAsyncThunk(
  'DRAWING/scanOCRExtraction',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.post(`${drawings.processOCRExtraction(arg.id)}`, {});
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const redefineAndScan = createAsyncThunk(
  'DRAWING/redefineAndScan',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.post(`${drawings.redefineAndScan(arg.id)}`, {
        pdf_coordinates: arg.pdf_coordinates
      });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const saveAnnotations = createAsyncThunk('DRAWING/saveExportView', async (arg, thunkAPI) => {
  try {
    return await API_SERVICE.post(`${drawings.saveAnnotations(arg.id)}`, arg.formData, true);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});
export const saveActivityLogCall = createAsyncThunk(
  'DRAWING/saveActivityLog',
  async (arg, thunkAPI) => {
    try {
      const url = `drawing_versions/${arg.id}/save_activity`;
      return await API_SERVICE.post(url, { ...arg?.save_activity_info });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const loadAnnotations = createAsyncThunk(
  'DRAWING/loadAnnotations',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.loadAnnotations(arg.id)}`, {});
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const saveMarkupAnnotations = createAsyncThunk(
  'DRAWING/saveMarkupAnnotations',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.post(`${drawings.saveMarkup(arg.id)}`, {
        annotations: arg.annotations,
        base_revision: arg.baseRevision
      });
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const loadMarkupAnnotations = createAsyncThunk(
  'DRAWING/loadMarkupAnnotations',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.get(`${drawings.loadMarkup(arg.id)}`);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const getLinkVersions = createAsyncThunk(
  'DRAWING/getLinkVersions',
  async (arg, thunkAPI) => {
    try {
      const params = arg.currentVersionId ? { current_version_id: arg.currentVersionId } : {};
      return await API_SERVICE.get(drawings.linkVersions(arg.projectId), params);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
// Every sheet in the current version's drawing set — used to resolve printed
// detail-callout references (e.g. "A3-1") to a navigable version id.
export const getSheetIndex = createAsyncThunk(
  'DRAWING/getSheetIndex',
  async (arg, thunkAPI) => {
    try {
      const params = arg.currentVersionId ? { current_version_id: arg.currentVersionId } : {};
      return await API_SERVICE.get(drawings.sheetIndex(arg.projectId), params);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const uploadMarkupPhoto = createAsyncThunk(
  'DRAWING/uploadMarkupPhoto',
  async (arg, thunkAPI) => {
    try {
      const form = new FormData();
      form.append('photo', arg.file);
      return await API_SERVICE.post(drawings.uploadMarkupPhoto(arg.id), form, true);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const uploadMarkupAttachment = createAsyncThunk(
  'DRAWING/uploadMarkupAttachment',
  async (arg, thunkAPI) => {
    try {
      const form = new FormData();
      form.append('file', arg.file);
      return await API_SERVICE.post(drawings.uploadMarkupAttachment(arg.id), form, true);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
// Atomically reserves the next revision-cloud number on the server. Used
// by the Revision Cloud tool's optimistic-then-correct flow: a provisional
// number is rendered immediately, the server's authoritative number
// replaces it when this resolves. On failure, the provisional stays.
export const fetchNextRevisionCloudNumber = createAsyncThunk(
  'DRAWING/fetchNextRevisionCloudNumber',
  async (arg, thunkAPI) => {
    try {
      return await API_SERVICE.post(drawings.nextRevisionCloudNumber(arg.id), {});
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const drawingSlice = createSlice({
  name: 'drawing',
  initialState,
  reducers: {
    setDrawingFileName: (state, { payload }) => {
      state.fileName = payload;
    },
    resetDrawingPendingList: (state, { payload }) => {
      state.drawingPendingList = [];
      state.set_name = '';
      state.annotateCoordinates = null;
      state.pdf_auto_scan_attrs = {
        coordinates_defined: false,
        auto_scan_initiated: false,
        auto_scan_completion: false
      };
      state.ocr_progress = {};
      state.scanEnable = false;
      state.titleCoordinates = null;
      state.numberCoordinates = null;
      state.referencePageDimensions = null;
      state.dimensionGroups = [];
      state.activeGroupSignature = null;
      state.groupCoordinates = {};
    },
    resetOCR: (state, { payload }) => {
      state.ocr_progress = {};
      // Clear the stale completion flag from any previous scan so a re-scan
      // starts the progress poll instead of showing the old "completed" state.
      if (state.pdf_auto_scan_attrs) {
        state.pdf_auto_scan_attrs = {
          ...state.pdf_auto_scan_attrs,
          auto_scan_completion: false
        };
      }
    },
    setScanEnable: (state, { payload }) => {
      state.scanEnable = payload;
    },
    setAnnotateCoordinates: (state, { payload }) => {
      if (payload?.type) {
        if (payload.type === 'Number') state.numberCoordinates = payload.coordinates;
        if (payload.type === 'Title') state.titleCoordinates = payload.coordinates;
        if (payload.pageDims) state.referencePageDimensions = payload.pageDims;

        // When a dimension group is active, also write to the per-group map
        const sig = state.activeGroupSignature;
        if (sig) {
          const existing = state.groupCoordinates[sig] || {};
          state.groupCoordinates[sig] = {
            ...existing,
            [payload.type === 'Number' ? 'number' : 'title']: payload.coordinates
          };
        }
      }
    },
    setActiveGroup: (state, { payload }) => {
      state.activeGroupSignature = payload;
      const saved = state.groupCoordinates[payload] || {};
      state.titleCoordinates = saved.title || null;
      state.numberCoordinates = saved.number || null;
    },
    setTitleNumber: (state, { payload }) => {
      state.title = payload.title;
      state.number = payload.number;
    },
    resetTitleNumber: (state, { payload }) => {
      state.title = '-';
      state.number = '-';
    },
    openRedefineModal: (state, { payload }) => {
      state.redefineModalOpen = true;
      state.redefineRecord = payload;
      state.pageTitleCoordinates = payload.effective_coordinates?.title || null;
      state.pageNumberCoordinates = payload.effective_coordinates?.number || null;
    },
    closeRedefineModal: (state) => {
      state.redefineModalOpen = false;
      state.redefineRecord = null;
      state.pageTitleCoordinates = null;
      state.pageNumberCoordinates = null;
    },
    setPageAnnotateCoordinates: (state, { payload }) => {
      if (payload?.type === 'Number') state.pageNumberCoordinates = payload.coordinates;
      if (payload?.type === 'Title') state.pageTitleCoordinates = payload.coordinates;
    },
    onChangeRowValues: (state, { payload }) => {
      let rowModify = '';
      state.drawingPendingList = state.drawingPendingList.map((v) => {
        // rowModify = v.unique_reference_id === payload.unique_reference_id;
        if (v.unique_reference_id === payload.unique_reference_id) {
          rowModify = true;
          return { ...v, [payload.name]: payload.value, currentField: true };
        }
        return { ...v, currentField: false };

        // return v.unique_reference_id === payload.unique_reference_id
        //   ? { ...v, [payload.name]: payload.value, currentField: true }
        //   : { ...v, currentField: false };
      });
      state.rowModify = rowModify;
    }
    // setTitleCoordinates: (state, { payload }) => {
    //   state.titleCoordinates = payload;
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(addDrawingArea.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingAreas = [...state.drawingAreas, payload.data.data];
      }
    });
    builder.addCase(getDrawingAreas.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingAreas = payload.data.data;
      }
    });
    builder.addCase(updateDrawingArea.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        const temp = state.drawingAreas.filter((e) => e.id !== payload.data.data.id);
        state.drawingAreas = [...temp, payload.data.data];
      }
    });
    builder.addCase(editDrawingArea.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.editArea = payload.data.data;
      }
    });
    builder.addCase(saveSheetDetails.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.rowModify = false;
        state.rowUpdate = 'Drawing Review updated successfully';
      }
    });
    builder.addCase(scanOCRExtraction.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.rowUpdate = 'Drawing Review scan updated successfully';
      }
    });
    builder.addCase(redefineAndScan.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.redefineModalOpen = false;
        state.redefineRecord = null;
        state.pageTitleCoordinates = null;
        state.pageNumberCoordinates = null;
      }
    });
    builder.addCase(getDrawingList.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingList = payload.data;
      }
    });
    builder.addCase(drawingPendingApproval.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingPendingList = payload.data.drawings;
        state.pdf_auto_scan_attrs = payload.data.pdf_auto_scan_attrs;
        state.set_name = payload.data.set_name;
        state.ocr_progress = payload.data?.ocr_progress;
      }
    });
    builder.addCase(drawingDefinedProperties.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingPendingList = payload.data.drawings;
        state.pdf_auto_scan_attrs = payload.data.pdf_auto_scan_attrs;
        state.set_name = payload.data.set_name;
        state.ocr_progress = payload.data?.ocr_progress;

        const groups = payload.data.dimension_groups || [];
        state.dimensionGroups = groups;
        if (groups.length > 0) {
          const seeded = {};
          groups.forEach((g) => {
            if (g.saved_coordinates) seeded[g.signature] = g.saved_coordinates;
          });
          state.groupCoordinates = seeded;
          state.activeGroupSignature = groups[0].signature;
          const first = seeded[groups[0].signature] || {};
          state.titleCoordinates = first.title || null;
          state.numberCoordinates = first.number || null;
        } else {
          state.dimensionGroups = [];
          state.activeGroupSignature = null;
          state.groupCoordinates = {};
        }
      }
    });
    builder.addCase(savePDFCoordinates.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.savePDFCoordinate = payload.data;
      }
    });
    builder.addCase(processAutoScan.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.autoScan = payload.data;
        state.ocr_progress = {};
      }
    });
    builder.addCase(getDrawingSetList.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingSetList = payload.data;
      }
    });
    builder.addCase(deleteDrawingArea.fulfilled, (state, { payload }) => {
      if (payload.status === 200 || payload.status === 201) {
        state.drawingAreas = state.drawingAreas.filter((e) => e.id !== deleteID);
      }
    });
    builder.addCase(getUploadLogs.fulfilled, (state, { payload }) => {
      if (payload.status === 200) {
        state.uploadLogs = payload.data.data;
      }
    });
    builder.addCase(drawingApproval.fulfilled, (state, { payload }) => {
      if (payload.status === 200) {
        state.approvalDrawing = payload.data.data;
      }
    });
    builder.addCase(getExistingDrawingSet.fulfilled, (state, { payload }) => {
      if (payload.status === 200) {
        state.existingDrawingSet = payload.data;
      }
    });
  }
});
export const {
  setDrawingFileName,
  resetDrawingPendingList,
  setAnnotateCoordinates,
  setTitleNumber,
  resetTitleNumber,
  onChangeRowValues,
  resetOCR,
  setScanEnable,
  openRedefineModal,
  closeRedefineModal,
  setPageAnnotateCoordinates,
  setActiveGroup
} = drawingSlice.actions;
export default drawingSlice.reducer;
